import { Directive, Output, HostListener, EventEmitter } from '@angular/core';

// eslint-disable-next-line @angular-eslint/directive-selector
@Directive({ selector: '[upDragAndDrop]' })
export class UtilsDragDropDirective {
  @Output() filesDropped = new EventEmitter<FileList>();
  @Output() fileHover = new EventEmitter();

  @HostListener('drop', ['$event'])
  drop($event): void {
    $event.preventDefault();
    const transfer: FileList = $event.dataTransfer.files;

    this.fileHover.emit(false);

    if (transfer.length > 0 && transfer.length < 2) {
      this.filesDropped.emit(transfer);
    }
  }

  @HostListener('dragover', ['$event'])
  dragover($event): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.fileHover.emit(true);
  }

  @HostListener('dragleave', ['$event'])
  dragleave(): void {
    this.fileHover.emit(false);
  }
}
